import {
  Box,
  Link,
  Toolbar,
  LinkProps,
  AppBarProps,
} from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'html-react-parser';

const NavLink = styled(Link)<LinkProps>(({ theme }) => ({
  color: "#3D3D3D",
  margin: "0 15px",
  cursor: "pointer",
}));

const FooterBar = styled(Box)<AppBarProps>(({ theme }) => ({
  background: "#fff",
  position: "relative",
}));

const Footer = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FooterBar sx={{ boxShadow: 1, display: "flex", paddingTop: "15px", paddingBottom: "15px" }}>
        <Toolbar sx={{width:"100%"}}>
            <Box>
              <div style={{ alignItems: "left", fontSize: "12px" }}>
                {ReactHtmlParser(t("footer_micetype"))}
              </div>
            </Box>
            <Box className="footer-right-content" justifyContent="flex-end" alignItems="center" sx={{ flexGrow: 1, display:"flex" }}>
              <NavLink
                style={{ color:"#3B97DE", marginRight: "75px", textDecoration: "underline" }}
                target="_blank"
                rel="noopener"
                href={t("privacy_policy_url")}
              >
                {t("privacy_policy")}
              </NavLink>
              <NavLink>
                <img
                  className="footer-logo"
                  src="/assets/amgen-blue.png"
                  alt="Amgen"
                  style={{ marginBottom: 0, height: "30px" }}
                />
              </NavLink>
            </Box>
        </Toolbar>
      </FooterBar>
    </React.Fragment>
  );
};

export default Footer;
